<template>
<div>

    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="branchRecordWithchangeFilter" placeholder="Select Branch"></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="user.type == 'admin'">
              <label for="Designation">Designation</label>
              <v-select v-model="designation" name="designation_id" label="name" :options="designations" placeholder="Select Designation" v-on:input="loadStaff"></v-select>
              
              <has-error
                :form="form"
                field="designation_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="user.type == 'admin' || user.role_id == 5">
              <span>
                <label for="Designation">Staff</label>
                <v-select v-model="staff" name="staff_id" label="name" :options="staffs" placeholder="Select Staff" v-on:input="changeFilter"></v-select>
                
                <has-error
                  :form="form"
                  field="staff_id"
                ></has-error>
              </span>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label
                  >Select Status <span class="red">*</span></label
                >
                <select
                  v-model="form.status"
                  name="status"
                  class="form-control"
                  @change="changeFilter"
                  :class="{
                    'is-invalid': form.errors.has('status'),
                  }"
                >
                  <option v-if="!form.status" selected value="">
                    Select Status
                  </option>
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="verified">Verified</option>
                  <option value="reject">Reject</option>
                </select>
                <has-error :form="form" field="status"></has-error>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <!-- <div class="box" v-if="canAccess('member-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Customer List</h3>
          <span class="float-right" >
            <button v-if="canAccess('member-create')" type="button" class="btn btn-sm btn-success" @click="newModal"><i class="fa fa-plus"></i></button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed small"
                :line-numbers="true"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Code'" >
                    <span style="font-size: 13px; font-weight: bold; color:#3c8dbc;">{{props.row.user.code}}</span>
                  </span>
                  
                  <span v-if="props.column.field == 'Email'" >
                    <span style="font-size: 12px;">{{props.row.user.email}}</span>
                  </span>

                  <span v-if="props.column.field == 'Father'" >
                    <span style="font-size: 12px;">{{props.row.fatherName}}</span>
                  </span>
                  <span v-if="props.column.field == 'SpouseName'" >
                    <span style="font-size: 13px;">{{props.row.spouseName}}</span>
                  </span>

                  <span v-if="props.column.field == 'Phone'" >
                    <span style="font-size: 13px;"><i class="fa fa-check-circle-o text-success" v-show="props.row.user.mobileVerify == 'true'"></i>{{props.row.user.mobile}}</span>
                  </span>
                  <span v-if="props.column.field == 'Branch'" >
                    <span style="font-size: 13px;">{{props.row.branch.name}}</span>
                  </span>
                  <span v-if="props.column.field == 'Status'" >
                    <p v-if="props.row.status == 'pending'" class="text-warning bg-warning text-center">{{props.row.status}}</p>
                    <p v-if="props.row.status == 'verified'" class="text-success bg-success text-center">{{props.row.status}}</p>
                    <p v-if="props.row.status == 'reject'" class="text-danger bg-danger text-center">{{props.row.status}}</p>
                  </span>
                  <span v-if="props.column.field == 'id'">
                     <button
                      v-if="canAccess('member-create')"
                      class="btn btn-warning btn-xs"
                      @click="docModal(props.row)" title="Upload User Document"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                    <button
                      v-if="canAccess('member-document-verify')"
                      class="btn btn-danger btn-xs"
                      @click="verifyModal(props.row)" title="Verify Customer KYC"
                    >
                       <i class="fa fa-check-square"></i>
                    </button>
                    <button
                      v-if="canAccess('member-view')"
                      class="btn btn-info btn-xs"
                      @click="viewModal(props.row)"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <div v-if="canAccess('member-update')">
                      <button
                        v-if="(user.type != 'admin' && props.row.status != 'verified') || user.type == 'admin'"
                        @click="editModal(props.row)"
                        class="btn btn-success btn-xs"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                    </div>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
          </vue-good-table>
                
        </div>
        <div class="box-footer">
          List of all Customer
        </div>
      </div> -->
      <!-- /.box -->

      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('member-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Member List</h3>
          
          <div class="box-tools">
            <a :href="`${this.$axios.defaults.baseURL}/member/export/excel`" class="btn btn-box-tool" v-if="canAccess('member-create')">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('member-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-12">
              <div class="input-group pull-left input-group-sm" style="width: 160px;">
                <input type="text" v-model="name_search" @keyup.enter="changeFilter()" name="name_search" class="form-control pull-right" placeholder="Name, Code, Mobile">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div style="overflow:auto;">
            <table class="table table-sm table-bordered table-hover">
              <thead style="background-color: #d6dddd;">
                <tr>
                  <th class="hidden-xs">Sr.</th>
                  <th>Code </th>
                  <th>Name</th>
                  <!-- <th class="hidden-xs">Email</th> -->
                  <th class="hidden-xs">Father Name (C/O)</th>
                  <th class="hidden-xs">Spouse Name</th>
                  <th class="hidden-xs">BirthDate</th>
                  <th class="hidden-xs">AadharCardNumber</th>
                  <th class="hidden-xs">PancardNumber</th>
                  <th class="hidden-xs">Mobile</th>
                  <th class="hidden-xs">City</th>
                  <th class="hidden-xs">Agent</th>
                  <th class="hidden-xs">Branch</th>
                  <th class="hidden-xs">CreateDate</th>
                  <th class="hidden-xs">KYC Status</th>
                  <th class="hidden-xs">Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                  <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                  <td>{{ row.user.code }}</td>
                  <!-- <td><router-link :to="/customerdetails/ + row.user_id"><i class="fa fa-info-circle"></i> {{ row.user.name }}</router-link></td> -->
                  <td>{{ row.user.name }}</td>
                  <!-- <td class="hidden-xs">{{ row.user.email }}</td> -->
                  <td class="hidden-xs">{{ row.fatherName }}</td>
                  <td class="hidden-xs">{{ row.spouseName }}</td>
                  <td class="hidden-xs">{{ row.dob }}</td>
                  <td class="hidden-xs">
                    <i v-if="row.aadharStatus === 'true'" class="fa fa-check-circle-o text-success" aria-hidden="true"></i>
                    <i v-else-if="row.aadharStatus === 'false'" class="fa fa-times-circle-o text-danger" aria-hidden="true"></i>
                    <i v-else class="fa fa-exclamation-circle text-warning" aria-hidden="true"></i>
                    {{ row.aadharNo }}
                  </td>
                  <td class="hidden-xs">
                    <i v-if="row.panStatus === 'true'" class="fa fa-check text-success" aria-hidden="true"></i>
                    <i v-else-if="row.panStatus === 'false'" class="fa fa-times text-danger" aria-hidden="true"></i>
                    <i v-else class="fa fa-exclamation-circle text-warning" aria-hidden="true"></i>
                    {{ row.panNo }}</td>
                  <td class="hidden-xs"><i class="fa fa-check-circle-o text-success" v-show="row.user.mobileVerify == 'true'"></i> {{row.user.mobile}}</td>
                  <td class="hidden-xs">{{ row.city }}</td>
                  <td class="hidden-xs"><span v-if="row.agent">{{ row.agent.name }}</span></td>
                  <td class="hidden-xs"><span v-if="row.branch">{{ row.branch.name }}</span></td>
                  <td class="hidden-xs">{{ row.created_at | myDate}}</td>
                  <td class="hidden-xs">
                    <div v-if="row.status == 'verified'">
                      <span class="label label-success">verified</span>
                    </div>
                    <div v-if="row.status == 'pending'">
                      <span class="label label-warning">pending</span>
                    </div>
                    <div v-if="row.status == 'reject'">
                      <span class="label label-danger">reject</span>
                    </div>
                  </td>
                  <td class="hidden-xs text-center">
                    <div v-if="row.user.status == 'active'">
                      <i class="text-success fa fa-check-circle" style="font-size: 20px;"></i>
                    </div>
                    <div v-else>
                      <i class="text-danger fa fa-remove"></i>
                    </div>
                  </td>
                  <td>
                    <div class="btn-group">
                      <!-- <button type="button" class="btn btn-xs btn-info">Act</button> -->
                      <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                        Action <span class="caret"></span>
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-right" role="menu">
                        <li v-if="canAccess('member-create')">
                          <a @click="docModal(row)"><i class="fa fa-file"></i> Upload Document </a>
                        </li>
                        <li v-if="canAccess('member-document-verify')">
                          <a @click="verifyModal(row)"><i class="fa fa-check-square"></i> Verify KYC </a>
                        </li>
                        <li v-if="canAccess('member-view')">
                          <a @click="viewModal(row)"><i class="fa fa-eye"></i> Customer Details </a>
                        </li>
                        <li v-if="canAccess('member-update')">
                          <a @click="viewInfo"><i class="fa fa-black-tie"></i> Customer Cibil</a>
                        </li>
                        <li v-if="(user.type != 'admin' && row.status != 'verified') || user.type == 'admin' && canAccess('member-update')">
                          <a @click="editModal(row)"><i class="fa fa-pencil"></i> Customer Update</a>
                        </li>
                        <li v-if="canAccess('member-view')">
                            <router-link :to="/customerloandetails/ + row.user_id"><i class="fa fa-leanpub"></i> Loan Details</router-link>
                        </li>
                      </ul>
                      
                      <!-- <button
                        v-if="canAccess('member-create')"
                        class="btn btn-warning btn-xs"
                        @click="docModal(row)" title="Upload User Document"
                      >
                        <i class="fa fa-file"></i>
                      </button> -->
                      <!-- <button
                        v-if="canAccess('member-document-verify')"
                        class="btn btn-danger btn-xs"
                        @click="verifyModal(row)" title="Verify Customer KYC"
                      >
                        <i class="fa fa-check-square"></i>
                      </button> -->
                      <!-- <button
                        v-if="canAccess('member-view')"
                        class="btn btn-info btn-xs"
                        @click="viewModal(row)"
                        title="View Customer Details"
                      >
                        <i class="fa fa-eye"></i>
                      </button> -->
                      <!-- <button
                        v-if="canAccess('member-update')"
                        class="btn btn-warning btn-xs"
                        @click="viewInfo"
                        title="Check Customer Cibil"
                      >
                        <i class="fa fa-black-tie"></i>
                      </button> -->
                      <!-- <span v-if="canAccess('member-update')"> -->
                        <!-- <button
                          v-if="(user.type != 'admin' && row.status != 'verified') || user.type == 'admin' && canAccess('member-update')"
                          @click="editModal(row)"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-pencil"></i>
                        </button> -->
                      <!-- </span> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->

    </section>
    
      <!-- /.modal -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Add Member Details</h4>
              <h4 v-show="editMode" class="modal-title">
                Update Member Details
              </h4>
            </div>
            <form @submit.prevent="editMode ? editMember() : createMember()" class="form-horizontal">
              <div class="modal-body">
                <!-- right column -->
                <div class="row">
                  
                  <div class="col-md-12">
                    <div class="nav-tabs-custom">
                        <ul class="nav nav-tabs">
                          <li class="tab1 active">
                            <a id="mainDoc" href="#">Main</a>
                          </li>
                          <li class="tab2">
                            <a id="Identification" href="#">User Identification</a>
                          </li>
                          <li class="tab3">
                            <a id="relLoc" href="#">Bank Details</a>
                          </li>

                          <li class="tab4">
                            <a id="inc" href="#">Income</a>
                          </li>
                          <li class="tab5">
                            <a id="refer" href="#">Co-Applicant Details</a>
                          </li>

                          <!-- <li class="tab6">
                            <a id="nom" href="#">Nominee</a>
                          </li> -->
                        </ul>
                      
                        <div class="tab-content">
                          <div class="tab-pane active" id="main">
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Customer Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.name"
                                  type="text"
                                  name="name"
                                  required
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('name'),
                                  }"
                                  placeholder="Enter Customer name"
                                />
                                <has-error
                                  :form="form"
                                  field="name"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >(C/O) / Customer Alias Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.alias"
                                  type="text"
                                  name="alias"
                                  required
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('alias'),
                                  }"
                                  placeholder="Enter Customer alias"
                                />
                                <has-error
                                  :form="form"
                                  field="alias"
                                ></has-error>
                              </div>

                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Customer Mobile No.</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.mobile"
                                  type="number"
                                  name="mobile"
                                  required
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('mobile'),
                                  }"
                                  placeholder="Enter Mobile Number"
                                />
                                <has-error
                                  :form="form"
                                  field="mobile"
                                ></has-error>
                              </div>

                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Alternative Mobile No.</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.phone"
                                  type="number"
                                  name="phone"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('phone'),
                                  }"
                                  placeholder="Enter Alternative Mobile Number"
                                />
                                <has-error
                                  :form="form"
                                  field="phone"
                                ></has-error>
                              </div>

                              
                            </div>

                            <div class="form-group row">
                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Customer Email</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.email"
                                  type="email"
                                  name="email"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('email'),
                                  }"
                                  placeholder="Enter Customer Email"
                                />
                                <has-error
                                  :form="form"
                                  field="email"
                                ></has-error>
                              </div>
                              <label
                                for="inputSkills"
                                class="col-sm-2 col-form-label"
                                >Gender</label
                              >
                              <div class="col-sm-4">
                                <div class="form-check">
                                  <input
                                    v-model="form.gender"
                                    value="Male"
                                    id="customRadio1"
                                    class="form-check-input"
                                    :class="{
                                      'is-invalid': form.errors.has('gender'),
                                    }"
                                    type="radio"
                                    name="gender"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="customRadio1"
                                    >Male</label
                                  >
                                  <has-error
                                    :form="form"
                                    field="gender"
                                  ></has-error>
                                </div>
                                <div class="form-check">
                                  <input
                                    v-model="form.gender"
                                    value="Female"
                                    id="customRadio2"
                                    class="form-check-input"
                                    :class="{
                                      'is-invalid': form.errors.has('gender'),
                                    }"
                                    type="radio"
                                    name="gender"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="customRadio2"
                                    >Female</label
                                  >
                                  <has-error
                                    :form="form"
                                    field="gender"
                                  ></has-error>
                                </div>
                              </div>

                              <label
                                for="inputSkills"
                                class="col-sm-2 col-form-label"
                                >Date Of Birth</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.dob"
                                  type="date"
                                  name="dob"
                                  required
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('dob'),
                                  }"
                                />
                                <has-error :form="form" field="dob"></has-error>
                              </div>

                              <label
                                for="inputSkills"
                                class="col-sm-2 col-form-label"
                                >Password</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.password"
                                  type="password"
                                  name="password"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('password'),
                                  }"
                                />
                                <has-error :form="form" field="password"></has-error>
                              </div>

                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Pancard Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.panNo"
                                  type="text"
                                  name="panNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('panNo'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="panNo"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Adhar Card Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.aadharNo"
                                  type="text"
                                  name="aadharNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('aadharNo'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="aadharNo"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Father Name (C/O)</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.fatherName"
                                  type="text"
                                  name="fatherName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('fatherName'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="fatherName"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Mother Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.motherName"
                                  type="text"
                                  name="motherName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('motherName'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="motherName"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Spouse Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.spouseName"
                                  type="text"
                                  name="spouseName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('spouseName'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="spouseName"
                                ></has-error>
                              </div>
                              <label 
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Branch</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.branch_id"
                                  name="branch_id"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('branch_id'),
                                  }"
                                  @change="getBranchAgent"
                                  required
                                >
                                  <option
                                    v-if="!form.branch_id"
                                    selected
                                    value=""
                                  >
                                    Select Branch
                                  </option>
                                  <option
                                    :value="bra.id"
                                    v-for="bra in branches"
                                    :key="bra.id"
                                  >
                                    {{ bra.name }}
                                  </option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="branch_id"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputPincode"
                                class="col-sm-2 col-form-label"
                                >Pincode</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.pin"
                                  type="text"
                                  name="pin"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('pin'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="pin"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Address</label
                              >
                              <div class="col-sm-4">
                                <textarea
                                  v-model="form.address"
                                  type="text"
                                  name="address"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('address'),
                                  }"
                                  required
                                >
                                </textarea>
                                <has-error
                                  :form="form"
                                  field="address"
                                ></has-error>
                              </div>
                              
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Area</label
                              >
                              <div class="col-sm-4">
                                <textarea
                                  v-model="form.area"
                                  type="text"
                                  name="area"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('area'),
                                  }"
                                >
                                </textarea>
                                <has-error
                                  :form="form"
                                  field="area"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >City</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.city"
                                  type="text"
                                  name="city"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('city'),
                                  }"
                                  required
                                />
                                <has-error
                                  :form="form"
                                  field="city"
                                ></has-error>
                              </div>
                              
                            </div>
                            <div class="form-group row">
                             <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >District</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.district"
                                  type="text"
                                  name="district"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('district'),
                                  }"
                                  required
                                />

                                <has-error
                                  :form="form"
                                  field="district"
                                ></has-error>
                              </div>

                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >State</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.state_id"
                                  name="state_id"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('state_id'),
                                  }"
                                  required
                                >
                                  <option
                                    v-if="!form.state_id"
                                    selected
                                    value=""
                                  >
                                    Select State
                                  </option>
                                  <option
                                    :value="stat.id"
                                    v-for="stat in states"
                                    :key="stat.id"
                                  >
                                    {{ stat.name }}
                                  </option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="state_id"
                                ></has-error>
                              </div>
                               
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Nominee Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeName"
                                  type="text"
                                  name="nomineeName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineeName'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeName"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Nominee Mobile Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineePhone"
                                  type="text"
                                  name="nomineePhone"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineePhone'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineePhone"
                                ></has-error>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Nominee Spouse</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeSpouse"
                                  type="text"
                                  name="nomineeSpouse"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineeSpouse'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeSpouse"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Nominee DOB</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeDob"
                                  type="date"
                                  name="nomineeDob"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('nomineeDob'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeDob"
                                ></has-error>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Nominee AdharCard No</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeAadharNo"
                                  type="text"
                                  name="nomineeAadharNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineeAadharNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeAadharNo"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label v-show="form.branch_id" v-if="user.type === 'admin' || user.role_id === 5"
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Staff</label
                              >
                              <div class="col-sm-4" v-show="form.branch_id" v-if="user.type === 'admin' || user.role_id === 5">
                                <v-select v-model="ag" name="agent_id" label="name" :options="agents" placeholder="Select Staff" v-on:input="getAgentId">

                                </v-select>
                                <has-error
                                  :form="form"
                                  field="agent_id"
                                ></has-error>
                              </div>
                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Purpose</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.purpose_id"
                                  name="purpose_id"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('purpose_id'),
                                  }"
                                  required
                                >
                                  <option
                                    v-if="!form.purpose_id"
                                    selected
                                    value=""
                                  >
                                    Select Purpose
                                  </option>
                                  <option
                                    :value="purpose.id"
                                    v-for="purpose in purposes"
                                    :key="purpose.id"
                                  >
                                    {{ purpose.purpose }}
                                  </option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="purpose_id"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row" v-show="editMode">
                              <div class="offset-sm-3 col-sm-9">
                                <button
                                  type="button"
                                  @click="saveMain"
                                  class="btn-primary float-right"
                                >
                                  Next
                                  <small
                                    ><i
                                      class="fa fa-arrow-right"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- /.tab-pane -->
                          <div class="tab-pane" id="uid">
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Driving License Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.drivingLicenceNo"
                                  type="text"
                                  name="drivingLicenceNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'drivingLicenceNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="drivingLicenceNo"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Ration Card Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.rationCardNo"
                                  type="text"
                                  name="rationCardNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'rationCardNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="rationCardNo"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Passport Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.passportNo"
                                  type="text"
                                  name="passportNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('passportNo'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="passportNo"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Voter ID Card Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.voterIdCardNo"
                                  type="text"
                                  name="voterIdCardNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'voterIdCardNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="voterIdCardNo"
                                ></has-error>
                              </div>
                            </div>

                            <div class="form-group row" v-show="editMode">
                              <div class="col-sm-6">
                                <button
                                  type="button"
                                  @click="backMain"
                                  class="btn-primary float-left"
                                >
                                  <small
                                    ><i
                                      class="fa fa-arrow-left"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                  Back
                                </button>
                              </div>
                              <div class="col-sm-6">
                                <button
                                  type="button"
                                  @click="saveUID"
                                  class="btn-success float-right"
                                >
                                  Save & Next
                                  <small
                                    ><i
                                      class="fa fa-arrow-right"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="tab-pane" id="relation">
                            <div class="form-group row">
                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Bank</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.bank_id"
                                  name="bank_id"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('bank_id'),
                                  }"
                                >
                                  <option
                                    v-if="!form.bank_id"
                                    selected
                                    value=""
                                  >
                                    Select Bank
                                  </option>
                                  <option
                                    :value="bank.id"
                                    v-for="bank in banks"
                                    :key="bank.id"
                                  >
                                    {{ bank.name }}
                                  </option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="bank_id"
                                ></has-error>
                              </div>
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Account Holder Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.accountHolderName"
                                  type="text"
                                  name="accountHolderName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('accountHolderName'),
                                  }"
                                />

                                <has-error
                                  :form="form"
                                  field="accountHolderName"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Account Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.accountNumber"
                                  type="text"
                                  name="accountNumber"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('accountNumber'),
                                  }"
                                />

                                <has-error
                                  :form="form"
                                  field="accountNumber"
                                ></has-error>
                              </div>
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Bank Branch</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.bankBranch"
                                  type="text"
                                  name="bankBranch"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('bankBranch'),
                                  }"
                                />

                                <has-error
                                  :form="form"
                                  field="bankBranch"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Bank IFSC Code</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.ifsc"
                                  type="text"
                                  name="ifsc"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('ifsc'),
                                  }"
                                />

                                <has-error
                                  :form="form"
                                  field="ifsc"
                                ></has-error>
                              </div>

                             
                            </div>
                          
                            <div class="form-group row" v-show="editMode">
                              <div class="col-sm-12">
                                <button
                                  type="button"
                                  @click="backRel"
                                  class="btn-primary float-left"
                                >
                                  <small
                                    ><i
                                      class="fa fa-arrow-left"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                  Back
                                </button>

                                <button
                                  type="button"
                                  @click="saveRel"
                                  class="btn-success float-right"
                                >
                                  Save & Next
                                  <small
                                    ><i
                                      class="fa fa-arrow-right"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- /.tab-pane -->
                          <div class="tab-pane" id="income">
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Job Type</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.jobType"
                                  name="jobType"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('jobType'),
                                  }"
                                >
                                  <option
                                    v-if="!form.jobType"
                                    selected
                                    value=""
                                  >
                                    Select Job Type
                                  </option>
                                  <option value="BUSINESS">BUSINESS</option>
                                  <option value="SALARIED">SALARIED</option>
                                  <option value="SELF EMPLOYED">
                                    SELF EMPLOYED
                                  </option>
                                  <option value="SELF EMPLOYED PROFESSIONAL">
                                    SELF EMPLOYED PROFESSIONAL
                                  </option>
                                  <option value="OTHER">OTHER</option>
                                  <option value="NONE">NONE</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="jobType"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Income Type</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.incomeType"
                                  name="incomeType"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('incomeType'),
                                  }"
                                >
                                  <option
                                    v-if="!form.incomeType"
                                    selected
                                    value=""
                                  >
                                    Select Income Type
                                  </option>
                                  <option value="GROSS INCOME">
                                    Gross Income
                                  </option>
                                  <option value="NET INCOME">Net Income</option>
                                  <option value="NONE">NONE</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="incomeType"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Income Amount</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.incomeAmount"
                                  type="text"
                                  name="incomeAmount"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'incomeAmount'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="incomeAmount"
                                ></has-error>
                              </div>

                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Income Time</label
                              >
                              <div class="col-sm-4">
                                <select
                                  v-model="form.incomeTime"
                                  name="incomeTime"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('incomeTime'),
                                  }"
                                >
                                  <option
                                    v-if="!form.incomeTime"
                                    selected
                                    value=""
                                  >
                                    Select Income Type
                                  </option>
                                  <option value="MONTHLY">Monthly</option>
                                  <option value="YEARLY">Yearly</option>
                                  <option value="WEEKLY">Weekly</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="incomeTime"
                                ></has-error>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Min Amount</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.minAmount"
                                  type="number"
                                  name="minAmount"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('minAmount'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="minAmount"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Max Amount</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.maxAmount"
                                  type="number"
                                  name="maxAmount"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('maxAmount'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="maxAmount"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Business Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.businessName"
                                  type="text"
                                  name="businessName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'businessName'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="businessName"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Business Address</label
                              >
                              <div class="col-sm-4">
                                <textarea
                                  v-model="form.businessAddress"
                                  type="text"
                                  name="businessAddress"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'businessAddress'
                                    ),
                                  }"
                                >
                                </textarea>
                                <has-error
                                  :form="form"
                                  field="businessAddress"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Office Phone</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.officePhone"
                                  type="number"
                                  name="officePhone"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'officePhone'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="officePhone"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row" v-show="editMode">
                              <div class="col-sm-12">
                                <button
                                  type="button"
                                  @click="backInc"
                                  class="btn-primary float-left"
                                >
                                  <small
                                    ><i
                                      class="fa fa-arrow-left"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                  Back
                                </button>

                                <button
                                  type="button"
                                  @click="saveInc"
                                  class="btn-success float-right"
                                >
                                  Save & Next
                                  <small
                                    ><i
                                      class="fa fa-arrow-right"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- /.tab-pane -->
                          <div class="tab-pane" id="reference">
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Co-Applicant Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.guarantorName"
                                  type="text"
                                  name="guarantorName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'guarantorName'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="guarantorName"
                                ></has-error>
                              </div>

                              <label
                                for="inputName2"
                                class="col-sm-2 col-form-label"
                                >Co-Applicant Mobile No.</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.guarantorPhone"
                                  type="text"
                                  name="guarantorPhone"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'guarantorPhone'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="guarantorPhone"
                                ></has-error>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Co-Applicant Address</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.guarantorAddress"
                                  type="text"
                                  name="guarantorAddress"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'guarantorAddress'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="guarantorAddress"
                                ></has-error>
                              </div>

                              <label
                                for="inputSkills"
                                class="col-sm-2 col-form-label"
                                >Co-Applicant Relation</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.guarantorNarration"
                                  type="text"
                                  name="guarantorNarration"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'guarantorNarration'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="guarantorNarration"
                                ></has-error>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Pancard Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.guarantorPanNo"
                                  type="text"
                                  name="guarantorPanNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'guarantorPanNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="guarantorPanNo"
                                ></has-error>
                              </div>

                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Adhar Card Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.guarantorAadharNo"
                                  type="text"
                                  name="guarantorAadharNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'guarantorAadharNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="guarantorAadharNo"
                                ></has-error>
                              </div>
                            </div>
                            
                            <!-- <div class="form-group row">
                              <label
                                for="ReferPerson"
                                class="col-sm-2 col-form-label">
                              Reference Person</label>
                              <div class="col-sm-4">
                                <v-select v-model="ro" name="reference_id" label="name" :options="rows" v-on:input="getReferenceId" placeholder="Select Reference Person"></v-select>
                  
                                <has-error
                                  :form="form"
                                  field="reference_id"
                                ></has-error>
                              </div>
                            </div> -->
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <button
                                  type="button"
                                  @click="backRefer"
                                  class="btn-primary float-left"
                                >
                                  <small
                                    ><i
                                      class="fa fa-arrow-left"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                  Back
                                </button>

                                <button
                                  type="button"
                                  @click="editMember"
                                  class="btn-success float-right"
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- /.tab-pane -->

                          <!-- <div class="tab-pane" id="nominee"> -->
                            <!-- <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Nominee Name</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeName"
                                  type="text"
                                  name="nomineeName"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineeName'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeName"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Nominee Mobile Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineePhone"
                                  type="text"
                                  name="nomineePhone"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineePhone'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineePhone"
                                ></has-error>
                              </div>
                            </div> -->

                            <!-- <div class="form-group row">
                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Spouse</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeSpouse"
                                  type="text"
                                  name="nomineeSpouse"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineeSpouse'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeSpouse"
                                ></has-error>
                              </div>

                              <label
                                for="inputEmail"
                                class="col-sm-2 col-form-label"
                                >Nominee DOB</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeDob"
                                  type="date"
                                  name="nomineeDob"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('nomineeDob'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeDob"
                                ></has-error>
                              </div>
                            </div> -->

                            <!-- <div class="form-group row">
                              <label
                                for="inputName"
                                class="col-sm-2 col-form-label"
                                >Adhar Card Number</label
                              >
                              <div class="col-sm-4">
                                <input
                                  v-model="form.nomineeAadharNo"
                                  type="text"
                                  name="nomineeAadharNo"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'nomineeAadharNo'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="nomineeAadharNo"
                                ></has-error>
                              </div>
                            </div> -->
                            <!-- <div class="form-group row">
                              <div class="col-sm-12">
                                <button
                                  type="button"
                                  @click="backNom"
                                  class="btn-primary float-left"
                                >
                                  <small
                                    ><i
                                      class="fa fa-arrow-left"
                                      aria-hidden="true"
                                    ></i
                                  ></small>
                                  Back
                                </button>
                              </div>
                            </div> -->
                          <!-- </div> -->
                          <!-- /.tab-pane -->
                        </div>
                        <!-- /.tab-content -->
                     
                    </div>
                    <!-- /.nav-tabs-custom -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>

              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  SAVE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CLOSE
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="verifyModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Verify Customer Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row" v-if="seeUser.user">
                <div class="col-md-3">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <div class="text-center">
                        <img
                          class="profile-user-img img-fluid img-responsive"
                          :src= this.photo
                          alt="User profile picture"
                        />
                      </div>
                      <br>
                      <div class="form-group text-center">
                        <label>
                          <input type="radio" name="photoStatus" class="minimal" value="true"  v-model="form.photoStatus">
                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                        </label>
                        <label>
                          <input type="radio" name="photoStatus" class="minimal" value="false"  v-model="form.photoStatus">
                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                        </label>
                        <br>
                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                        > <i class="fa fa-save"></i> Save</button
                      >
                        <button @click="imageZoom(photo)" class="btn btn-info btn-xs"
                        > <i class="fa fa-eye"></i> View</button>
                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                        > <i class="fa fa-trash"></i> Delete</button>
                      </div>
                        <br>
                      <h3 class="profile-username text-center">
                        {{ seeUser.user.name }} 
                      </h3>
                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>Code</b>
                          <a class="pull-right" v-if="seeUser.user">{{seeUser.user.code}}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Contact</b>
                          <a class="pull-right" v-if="seeUser.user">91-{{ seeUser.user.mobile }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Mobile Number Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.user.mobileVerify == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Photo Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.photoStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Pancard Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.panStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Aadhar Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.aadharStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Bank Passbook </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.passbookStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Ration Card </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.rationCardStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Driving Licence </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.drivingLicenceStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>DPN Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.demandProcessingNoteStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>JLG Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.jointLiabilityGroupStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Mob </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Photo </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorPhotoStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Aadhar</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorAadharStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Pan </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorPanStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-9">
                  <div class="card">
                    <div class="nav-tabs-custom">
                      <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#verifyCustomer"
                            data-toggle="tab"
                            >Verify Customer</a
                          >
                        </li>

                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#verifyGuarantor"
                            data-toggle="tab"
                            >Verify Co-Applicant</a
                          >
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-header -->
                    <div class="tab-content">
                      <div class="tab-content">
                        <!-- /.tab-pane -->
                        <div class="tab-pane active" id="verifyCustomer">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h4 class="card-title">Customer Details</h4>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-7">
                                  <div class="card-body box-profile">
                                    <p><strong>KYC Status </strong></p>
                                    <div class="form-group">
                                      <label>
                                        <input type="radio" name="status" class="minimal" value="verified"  v-model="form.status">
                                        <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                      </label>
                                      <label>
                                        <input type="radio" name="status" class="minimal" value="pending"  v-model="form.status">
                                        <i class="fa fa-exclamation-triangle text-warning"></i> <span class="text-warning">Pending</span>
                                      </label>
                                      <label>
                                        <input type="radio" name="status" class="minimal" value="reject"  v-model="form.status">
                                        <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                      </label>
                                      <button @click="verifyCustomerStatus" class="btn btn-primary btn-xs"
                                      > <i class="fa fa-save"></i> Save</button>
                                    </div>
                                    <!-- <div class="form-group">
                                      
                                      <select
                                        v-model="form.status"
                                        name="status"
                                        class="form-control"
                                        :class="{
                                          'is-invalid': form.errors.has('status'),
                                        }"
                                        required
                                      >
                                        <option v-if="!form.status" selected value="">
                                          Select Status
                                        </option>
                                        <option value="verified">Verified</option>
                                        <option value="pending">Pending</option>
                                        <option value="reject">Reject</option>
                                      </select>
                                      <has-error :form="form" field="status"></has-error>
                                    </div>
                                    <button @click="verifyCustomerStatus" class="btn btn-success btn-block"
                                      ><b>Customer KYC Status</b></button
                                    > -->
                                    
                                  </div>
                                </div>
                                <div class="col-md-5 col-xs-12" v-show="seeUser.user.mobileVerify != 'true'">
                                  <p><strong><i class="fa fa-mobile text-danger"></i> Customer Mobile Verify</strong>
                                    <button  @click="sendOTP" class="btn btn-info btn-xs fa fa-paper-plane" > OTP</button>
                                  </p>
                                  <div class="input-group input-group-xs">   
                                    <input
                                      v-model="form.otp"
                                      type="text"
                                      name="otp"
                                      placeholder="Please Enter OTP"
                                      class="form-control input-sm"
                                      :class="{
                                        'is-invalid': form.errors.has(
                                          'otp'
                                        ),
                                      }"
                                    />
                                    <has-error
                                      :form="form"
                                      field="otp"
                                    ></has-error>
                                      <span class="input-group-btn">
                                        <button type="button" @click="sendOTPVerify"  class="btn btn-success btn-sm"><strong>Verify OTP</strong></button>
                                      </span>
                                    </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <br>
                                  <div class="card border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        PANCARD DETAILS
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <!-- <li class="list-group-item">
                                          <b>Customer Login Status</b>
                                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.user.status == 'active'"></a>
                                          <a class="pull-right fa fa-close text-danger" v-else></a>
                                        </li> -->
                                        <li class="list-group-item">
                                          <b>Pancard Number</b>
                                          <p class="pull-right" v-show="seeUser.panNo">{{ seeUser.panNo }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.user">{{ seeUser.user.name }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Father Name</b>
                                          <p class="pull-right" v-show="seeUser.fatherName">{{ seeUser.fatherName }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>DOB</b>
                                          <p class="pull-right" v-show="seeUser.dob">{{ seeUser.dob | myDate }}</p>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.pan
                                          alt="customer pancard picture"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="panStatus" class="minimal" value="true"  v-model="form.panStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="panStatus" class="minimal" value="false"  v-model="form.panStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(pan)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> View</button>
                                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                        > <i class="fa fa-trash"></i> Delete</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>

                                <div class="col-md-6">
                                  <br>
                                  <div class="card border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        BANK PASSBOOK
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Acc. Number</b>
                                          <p class="pull-right" v-show="seeUser.accountNumber">{{ seeUser.accountNumber }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Account Holder</b>
                                          <p class="pull-right" v-show="seeUser.accountHolderName">{{ seeUser.accountHolderName }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Ifsc</b>
                                          <p class="pull-right" v-show="seeUser.ifsc">{{ seeUser.ifsc }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Bank</b>
                                          <p class="pull-right" v-if="seeUser.bank">{{ seeUser.bank.name }}</p>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.passbook
                                          alt="User Bank Passbook"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="passbookStatus" class="minimal" value="true"  v-model="form.passbookStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="passbookStatus" class="minimal" value="false"  v-model="form.passbookStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(passbook)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> View</button>
                                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                        > <i class="fa fa-trash"></i> Delete</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                                
                                <div class="col-md-6">
                                  <br>
                                  <div class="card card-primary card-outline border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        RATIONCARD DETAILS
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Rationcard Number</b>
                                          <p class="pull-right" v-show="seeUser.rationCardNo">{{ seeUser.rationCardNo }}</p>
                                          <br>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.user">{{ seeUser.user.name }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Father Name</b>
                                          <p class="pull-right" v-show="seeUser.fatherName">{{ seeUser.fatherName }}</p>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.rationCard
                                          alt="User ration Card"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="rationCardStatus" class="minimal" value="true"  v-model="form.rationCardStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="rationCardStatus" class="minimal" value="false"  v-model="form.rationCardStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(rationCard)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> View</button>
                                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                        > <i class="fa fa-trash"></i> Delete</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <br>
                                  <div class="card card-primary card-outline border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        DRIVING LICENCE
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Licence No.</b>
                                          <p class="pull-right" v-show="seeUser.drivingLicenceNo">{{ seeUser.drivingLicenceNo }}</p>
                                          <br>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.user">{{ seeUser.user.name }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Father Name</b>
                                          <p class="pull-right" v-show="seeUser.fatherName">{{ seeUser.fatherName }}</p>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.drivingLicence
                                          alt="customer driving licence"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="drivingLicenceStatus" class="minimal" value="true"  v-model="form.drivingLicenceStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="drivingLicenceStatus" class="minimal" value="false"  v-model="form.drivingLicenceStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(drivingLicence)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> View</button>
                                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                        > <i class="fa fa-trash"></i> Delete</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <br>
                                  <div class="card card-primary card-outline border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        AADHAR DETAILS
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Aadhar Number</b>
                                          <p class="pull-right" v-show="seeUser.aadharNo">{{ seeUser.aadharNo }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.user">{{ seeUser.user.name }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Gender</b>
                                          <p class="pull-right" v-show="seeUser.gender">{{ seeUser.gender }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>DOB</b>
                                          <p class="pull-right" v-show="seeUser.dob">{{ seeUser.dob | myDate }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Address</b>
                                          <p class="pull-right" v-show="seeUser.address">{{ seeUser.address }} , {{seeUser.district}}<span v-if="seeUser.state">, {{ seeUser.state.name }}</span> <br></p>
                                          <br><br><br>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.aadhar
                                          alt="User Aadhar Card"
                                        />
                                        <br>
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.aadharBack
                                          alt="User Aadhar Card"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="aadharStatus" class="minimal" value="true"  v-model="form.aadharStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="aadharStatus" class="minimal" value="false"  v-model="form.aadharStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(aadhar)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> Front</button>
                                        <button @click="imageZoom(aadharBack)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> Back</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <br>
                                  <div class="card card-primary card-outline border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        VOTERCARD DETAILS
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Number</b>
                                          <p class="pull-right" v-show="seeUser.voterIdCardNo">{{ seeUser.voterIdCardNo }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.user">{{ seeUser.user.name }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Gender</b>
                                          <p class="pull-right" v-show="seeUser.gender">{{ seeUser.gender }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>DOB</b>
                                          <p class="pull-right" v-show="seeUser.dob">{{ seeUser.dob | myDate }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Address</b>
                                          <p class="pull-right" v-show="seeUser.address">{{ seeUser.address }} , {{seeUser.district}}<span v-if="seeUser.state">, {{ seeUser.state.name }}</span></p>
                                          <br><br><br>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.voterCard
                                          alt="User Aadhar Card"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="voterCardStatus" class="minimal" value="true"  v-model="form.voterCardStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="voterCardStatus" class="minimal" value="false"  v-model="form.voterCardStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(voterCard)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> View</button>
                                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                        > <i class="fa fa-trash"></i> Delete</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                              </div>
                              <div class="row">

                                <div class="col-md-6">
                                  <div class="card-body box-profile border-primary">
                                    
                                    <div class="text-center">
                                      <h3>DPN</h3>
                                      <img
                                        class="profile-user-img img-fluid"
                                        :src= this.dpn
                                        alt="User Bank Passbook"
                                      />
                                    </div>
                                    <div class="form-group text-center">
                                      <label>
                                        <input type="radio" name="demandProcessingNoteStatus" class="minimal" value="true"  v-model="form.demandProcessingNoteStatus">
                                        <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                      </label>
                                      <label>
                                        <input type="radio" name="demandProcessingNoteStatus" class="minimal" value="false"  v-model="form.demandProcessingNoteStatus">
                                        <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                      </label>
                                      <br>
                                      <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                      > <i class="fa fa-save"></i> Save</button
                                    >
                                      <button  @click="imageZoom(dpn)" class="btn btn-info btn-xs"
                                      > <i class="fa fa-eye"></i> View</button>
                                      <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                      > <i class="fa fa-trash"></i> Delete</button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="card-body box-profile border-primary">
                                    
                                    <div class="text-center">
                                      <h3>JLG</h3>
                                      <img
                                        class="profile-user-img img-fluid"
                                        :src= this.jlg
                                        alt="User ration Card"
                                      />
                                    </div>
                                    <div class="form-group text-center">
                                      <label>
                                        <input type="radio" name="jointLiabilityGroupStatus" class="minimal" value="true"  v-model="form.jointLiabilityGroupStatus">
                                        <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                      </label>
                                      <label>
                                        <input type="radio" name="jointLiabilityGroupStatus" class="minimal" value="false"  v-model="form.jointLiabilityGroupStatus">
                                        <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                      </label>
                                      <br>
                                      <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                      > <i class="fa fa-save"></i> Save</button
                                    >
                                      <button @click="imageZoom(jlg)" class="btn btn-info btn-xs"
                                      > <i class="fa fa-eye"></i> View</button>
                                      <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                      > <i class="fa fa-trash"></i> Delete</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->
                        <div class="tab-pane" id="verifyGuarantor">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h4 class="card-title">Co-Applicant Details</h4>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row" v-show="seeUser.guarantorStatus != 'true'">
                                <div class="col-md-6 col-xs-12">
                                  <strong
                                    ><input type="button" @click="sendOTPGuarantor" class="btn btn-info btn-block" value="Send OTP To Mobile"></strong
                                  >
                                 
                                </div>
                                <div class="col-md-6">
                                  <div class="input-group input-group-sm">
                                    <input
                                        v-model="form.otp"
                                        type="text"
                                        name="otp"
                                        placeholder="Please Enter OTP"
                                        class="form-control"
                                        :class="{
                                          'is-invalid': form.errors.has(
                                            'otp'
                                          ),
                                        }"
                                      />
                                      <has-error
                                        :form="form"
                                        field="otp"
                                      ></has-error>
                                      <span class="input-group-btn">
                                        <button type="button" @click="sendOTPVerifyGuarantor" class="btn btn-success btn-flat"><strong>Verify OTP</strong></button>
                                      </span>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                
                                <div class="col-md-6">
                                  <br>
                                  <div class="card card-primary card-outline border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        Co-Applicant AADHAR DETAILS
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Aadhar Number</b>
                                          <p class="pull-right" v-show="seeUser.guarantorAadharNo">{{ seeUser.guarantorAadharNo }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.guarantorName">{{ seeUser.guarantorName }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Phone</b>
                                          <p class="pull-right" v-show="seeUser.guarantorPhone">{{ seeUser.guarantorPhone }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Address</b>
                                          <p class="pull-right" v-show="seeUser.guarantorAddress">{{ seeUser.guarantorAddress }} </p>
                                          <br><br><br>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.guarantorAadhar
                                          alt="User profile picture"
                                        />
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.guarantorAadharBack
                                          alt="User profile picture"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="guarantorAadharStatus" class="minimal" value="true"  v-model="form.guarantorAadharStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="guarantorAadharStatus" class="minimal" value="false"  v-model="form.guarantorAadharStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(guarantorAadhar)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> Front</button>
                                        <button @click="imageZoom(guarantorAadharBack)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> Back</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <br>
                                  <div class="card card-primary card-outline border-primary">
                                    <div class="card-body box-profile">

                                      <h3 class="profile-username text-center">
                                        Co-Applicant PANCARD DETAILS
                                      </h3>

                                      <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item">
                                          <b>Pancard Number</b>
                                          <p class="pull-right" v-show="seeUser.guarantorPanNo">{{ seeUser.guarantorPanNo }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Name</b>
                                          <p class="pull-right" v-show="seeUser.guarantorName">{{ seeUser.guarantorName }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Narration</b>
                                          <p class="pull-right" v-show="seeUser.guarantorNarration">{{ seeUser.guarantorNarration }}</p>
                                        </li>
                                        <li class="list-group-item">
                                          <b>Address</b>
                                          <p class="pull-right" v-show="seeUser.guarantorAddress">{{ seeUser.guarantorAddress }} </p>
                                          <br><br><br>
                                        </li>
                                      </ul>
                                      <div class="text-center">
                                        <img
                                          class="profile-user-img img-fluid"
                                          :src= this.guarantorPan
                                          alt="User profile picture"
                                        />
                                      </div>
                                      <div class="form-group text-center">
                                        <label>
                                          <input type="radio" name="guarantorPanStatus" class="minimal" value="true"  v-model="form.guarantorPanStatus">
                                          <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                        </label>
                                        <label>
                                          <input type="radio" name="guarantorPanStatus" class="minimal" value="false"  v-model="form.guarantorPanStatus">
                                          <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                        </label>
                                        <br>
                                        <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                        > <i class="fa fa-save"></i> Save</button
                                      >
                                        <button @click="imageZoom(guarantorPan)" class="btn btn-info btn-xs"
                                        > <i class="fa fa-eye"></i> View</button>
                                        <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                        > <i class="fa fa-trash"></i> Delete</button>
                                      </div>
                                    </div>
                                    <!-- /.card-body -->
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <br>
                                  <div class="card-body box-profile border-primary">
                                    
                                    <div class="text-center">
                                      <h3>Co-Applicant PHOTO</h3>
                                      <img
                                        class="profile-user-img img-fluid"
                                        :src= this.guarantorPhoto
                                        alt="User profile picture"
                                      />
                                    </div>
                                    <div class="form-group text-center">
                                      <label>
                                        <input type="radio" name="guarantorPhotoStatus" class="minimal" value="true"  v-model="form.guarantorPhotoStatus">
                                        <i class="fa fa-check text-success"></i> <span class="text-success">Approve</span>
                                      </label>
                                      <label>
                                        <input type="radio" name="guarantorPhotoStatus" class="minimal" value="false"  v-model="form.guarantorPhotoStatus">
                                        <i class="fa fa-remove text-danger"></i> <span class="text-danger">Reject</span>
                                      </label>
                                      <br>
                                      <button @click="verifyDocuments" class="btn btn-primary btn-xs"
                                      > <i class="fa fa-save"></i> Save</button
                                    >
                                      <button @click="imageZoom(guarantorPhoto)" class="btn btn-info btn-xs"
                                      > <i class="fa fa-eye"></i> View</button>
                                      <button @click="verifyDocuments" class="btn btn-danger btn-xs"
                                      > <i class="fa fa-trash"></i> Delete</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        

                      </div>
                      <!-- /.tab-content -->
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.nav-tabs-custom -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Customer Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row" v-if="seeUser.user">
                <div class="col-md-3">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <div class="text-center">
                        <img
                          class="profile-user-img img-fluid img-responsive"
                          :src= this.photo
                          alt="User profile picture"
                        />
                      </div>

                      <h3 class="profile-username text-center">
                        {{ seeUser.user.name }}
                      </h3>

                      <p class="text-muted text-center">
                        Contact - 91-{{ seeUser.user.mobile }}
                      </p>

                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>Email</b>
                          <a class="float-right">{{ seeUser.user.email }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Phone Number</b>
                          <a class="float-right"><span v-show="seeUser.phone">{{ seeUser.phone }}, </span>{{seeUser.user.mobile}}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Gender</b>
                          <a class="float-right">{{ seeUser.gender }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>DOB</b>
                          <a class="float-right">{{ seeUser.dob }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch</b>
                          <a class="float-right">{{ seeUser.branch.name }}</a>
                        </li>
                      </ul>

                      <!-- <a href="#" class="btn btn-primary btn-block"
                        ><b>Short Info</b>
                      </a> -->
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-9">
                  <div class="card">
                    <div class="card-header p-2">
                      <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-info"
                            href="#viewrelation"
                            data-toggle="tab"
                            >Relation & Reference</a
                          >
                        </li>

                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-info"
                            href="#viewlocation"
                            data-toggle="tab"
                            >Location</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-primary"
                            href="#viewuid"
                            data-toggle="tab"
                            >User ID</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-info"
                            href="#viewincome"
                            data-toggle="tab"
                            >Income</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-warning"
                            href="#viewbusiness"
                            data-toggle="tab"
                            >Bank Details</a
                          >
                        </li>

                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-info"
                            href="#viewnominee"
                            data-toggle="tab"
                            >Nominee</a
                          >
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="tab-content">
                        <!-- /.tab-pane -->
                        <div class="tab-pane active" id="viewrelation">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h3 class="card-title">Relation & Reference</h3>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Father Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.fatherName }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Mother Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.motherName }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Spouse Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.spouseName }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Co-Applicant Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.guarantorName }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Agent Detail</strong
                                  >
                                  <p class="text-muted" v-if="seeUser.agent">
                                    {{ seeUser.agent.name }} ({{seeUser.agent.code}})
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Co-Applicant Mobile No.</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.guarantorPhone }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    Co-Applicant Address</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.guarantorAddress }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Co-Applicant Relation</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.guarantorNarration }}
                                  </p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->

                        <!-- /.tab-pane -->
                        <div class="tab-pane" id="viewlocation">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h3 class="card-title">Location</h3>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Address</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.address }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Area</strong
                                  >
                                  <p class="text-muted">{{ seeUser.area }}</p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >City</strong
                                  >
                                  <p class="text-muted">{{ seeUser.city }}</p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >District</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.district }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >State</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.state.name }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    State Code</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.state.stateCode }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Pincode</strong
                                  >
                                  <p class="text-muted"></p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->
                        <div class="tab-pane" id="viewuid">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h3 class="card-title">User Identification</h3>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Pancard Number</strong
                                  >
                                  <p class="text-muted">{{ seeUser.panNo }}</p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Adhar Card Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.aadharNo }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Driving License Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.drivingLicenceNo }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Ration Card Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.rationCardNo }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    Passport Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.passportNo }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Voter ID Card Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.voterIdCardNo }}
                                  </p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="viewincome">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h3 class="card-title">Income</h3>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Job Type</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.jobType }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Income Amount</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.incomeAmount }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Income Type</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.incomeType }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Income Duration</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.incomeTime }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    Min Amount</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.minAmount }}
                                  </p>
                                  <hr />
                                </div>
                                <div class="col-md-6">
                                  
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    Max Amount</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.maxAmount }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Business Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.businessName }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Business Address</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.businessAddress }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Office Phone</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.officePhone }}
                                  </p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="viewbusiness">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h3 class="card-title">
                                Bank Details & Business
                              </h3>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Bank Name</strong
                                  >
                                  <p class="text-muted" v-if="seeUser.bank">
                                    {{ seeUser.bank.name }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Account Holder Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.accountHolderName }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Account Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.accountNumber }}
                                  </p>
                                  <hr />
                                  
                                </div>
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Bank Branch</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.bankBranch }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >IFSC Code</strong
                                  >
                                  <p class="text-muted">{{ seeUser.ifsc }}</p>
                                  <hr />
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="viewnominee">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h3 class="card-title">Nominee</h3>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    Nominee Name</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.nomineeName }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i>
                                    Nominee Mobile Number</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.nomineePhone }}
                                  </p>
                                  <hr />
                                  
                                </div>
                                <div class="col-md-6">
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Spouse</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.nomineeSpouse }}
                                  </p>
                                  <hr />
                                  <strong
                                    ><i class="fas fa-cash-register mr-1"></i
                                    >Nominee DOB</strong
                                  >
                                  <p class="text-muted">
                                    {{ seeUser.nomineeDob }}
                                  </p>
                                  <hr />
                                 
                                </div>
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->
                      </div>
                      <!-- /.tab-content -->
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.nav-tabs-custom -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="docModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Customer Documents</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row" v-if="seeUser.user">
                <div class="col-md-3">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <div class="text-center">
                        <img
                          class="profile-user-img img-fluid img-responsive"
                          :src= this.photo
                          alt="User profile picture"
                        />
                      </div>

                      <h3 class="profile-username text-center">
                        {{ seeUser.user.name }}
                      </h3>
                      <div  v-if="seeUser.status !== 'verified'" >
                        <input v-if="seeUser.photoStatus != 'true'" type="file" accept="image/*" @change="uploadPhoto($event)" id="file-input">
                      </div>
                      <ul class="list-group list-group-unbordered mb-3" >
                        <!-- <li class="list-group-item">
                          <b>Customer Login Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.user.status == 'active'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li> -->
                        <li class="list-group-item">
                          <b>Mobile Number Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.user.mobileVerify == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Photo Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.photoStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Pancard Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.panStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Aadhar Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.aadharStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Bank Passbook Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.passbookStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Ration Card Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.rationCardStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Driving Licence Status</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.drivingLicenceStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Mob</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Photo</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorPhotoStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Aadhar</b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorAadharStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                        <li class="list-group-item">
                          <b>Co-Applicant Pan </b>
                          <a class="pull-right fa fa-check-circle-o text-success" v-if="seeUser.guarantorPanStatus == 'true'"></a>
                          <a class="pull-right fa fa-close text-danger" v-else></a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-9">
                  <div class="card">
                    <div class="card-header p-2">
                      <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-info"
                            href="#customerDoc"
                            data-toggle="tab"
                            >Customer Documents</a
                          >
                        </li>

                        <li class="nav-item">
                          <a
                            class="nav-link btn btn-sm btn-info"
                            href="#guarantorDoc"
                            data-toggle="tab"
                            >Co-Applicant Documents</a
                          >
                        </li>
                        
                      </ul>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="tab-content">
                        <!-- /.tab-pane -->
                        <div class="tab-pane active" id="customerDoc">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h4 class="card-title">Customer Documents</h4>
                            </div>
                            <!-- /.card-header -->
                            <div class="row">
                              
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Adhar Card Front
                                </h3>
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.aadhar
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.aadharStatus != 'true'" type="file" accept="image/*" @change="uploadAadhar($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Adhar Card Back
                                </h3>
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.aadharBack
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.aadharStatus != 'true'" type="file" accept="image/*" @change="uploadAadharBack($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Pan Card
                                </h3>
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.pan
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.panStatus != 'true'" type="file" accept="image/*" @change="uploadPan($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Voter ID Card
                                </h3>
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.voterCard
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.voterCardStatus != 'true'" type="file" accept="image/*" @change="uploadVoterCard($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Bank Passbook
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.passbook
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.passbookStatus != 'true'" type="file" accept="image/*" @change="uploadPassbook($event)" id="file-input">
                                    </div>
                                      <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              <div class="col-md-6">
                                <!-- Profile Image -->
                                <h3 class="profile-username text-primary">
                                  Ration Card 
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.rationCard
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.rationCardStatus != 'true'" type="file" accept="image/*" @change="uploadRationCard($event)" id="file-input">
                                    </div>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <!-- Profile Image -->
                                <h3 class="profile-username text-primary">
                                  DPN (Demand Promisary Note)
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.dpn
                                        alt="Demand Promisary Note"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.demandProcessingNoteStatus != 'true'" type="file" accept="image/*" @change="uploadDPN($event)" id="file-input">
                                    </div>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                            
                              <div class="col-md-6">
                                <!-- Profile Image -->
                                <h3 class="profile-username text-primary">
                                  JLG (Joint Liability Groups)
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.jlg
                                        alt="Joint Liability Group"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.jointLiabilityGroupStatus != 'true'" type="file" accept="image/*" @change="uploadJLG($event)" id="file-input">
                                    </div>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                            </div>
                            <div class="row">
                              
                              <div class="col-md-6">
                                <!-- Profile Image -->
                                <h3 class="profile-username text-primary">
                                  Driving Licence
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.drivingLicence
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.drivingLicenceStatus != 'true'" type="file" accept="image/*" @change="uploadDL($event)" id="file-input">
                                    </div>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                            </div>
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->

                        <!-- /.tab-pane -->
                        <div class="tab-pane" id="guarantorDoc">
                          <div class="card card-primary">
                            <div class="card-header">
                              <h2 class="card-title">Co-Applicant Documents</h2>
                            </div>
                            <!-- /.card-header -->
                            <div class="row">
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Co-Applicant Photo
                                </h3>
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                  
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.guarantorPhoto
                                        alt="User profile picture"
                                      />
                                    </div>

                                    
                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.guarantorPhotoStatus != 'true'" type="file" accept="image/*" @change="uploadPhotoGuarantor($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              <div class="col-md-6">
                                <h3 class="profile-username text-primary">
                                  Pan Card
                                </h3>
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.guarantorPan
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.guarantorPanStatus != 'true'" type="file" accept="image/*" @change="uploadPanGuarantor($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              <div class="col-md-6">
                                <!-- Profile Image -->
                                <h3 class="profile-username text-primary">
                                  Co-Applicant Adhar Front
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.guarantorAadhar
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.guarantorAadharStatus != 'true'" type="file" accept="image/*" @change="uploadAadharGuarantor($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              <div class="col-md-6">
                                <!-- Profile Image -->
                                <h3 class="profile-username text-primary">
                                  Co-Applicant Adhar Back
                                </h3>
                                <div class="card card-primary card-outline">
                                  <div class="card-body box-profile">
                                    <div class="text-center">
                                      <img
                                        class="img-responsive"
                                        :src= this.guarantorAadharBack
                                        alt="User profile picture"
                                      />
                                    </div>

                                    <div v-if="seeUser.status !== 'verified'">
                                      <input v-if="seeUser.guarantorAadharStatus != 'true'" type="file" accept="image/*" @change="uploadAadharBackGuarantor($event)" id="file-input">
                                    </div>
                                    <br>
                                  </div>
                                  <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                              </div>
                              
                            </div>
                            
                            <!-- /.card-body -->
                          </div>
                          <!-- /.card -->
                        </div>
                        <!-- /.tab-pane -->
                       

                      </div>
                      <!-- /.tab-content -->
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.nav-tabs-custom -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="imagemodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
              <h4 class="modal-title" id="myModalLabel">Image preview</h4>
            </div>
            <div class="modal-body">
              <img :src="this.imagePreview" id="imagepreview" style="width: 100%; height: 100%" >
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
import GetSettingRecord from '../../mixins/SettingRecords'
import { mapState } from 'vuex'
export default {
  name: 'Customer',
  mixins: [GetBranch, GetSettingRecord],
  computed: {
    ...mapState([
      'profile',
      'user'
    ])
  },
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      name_search: '',
      ro: {},
      imagePreview: this.$store.state.imageDefaultUrl,
      photo: 'https://via.placeholder.com/100/FFFF00/000000?text=Image',
      guarantorPhoto: this.$store.state.imageDefaultUrl + '150',
      pan: this.$store.state.imageDefaultUrl,
      voterCard: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      guarantorPan: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      aadhar: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      aadharBack: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      guarantorAadhar: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      guarantorAadharBack: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      passbook: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      drivingLicence: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      dpn: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      jlg: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      rationCard: this.$store.state.imageDefaultUrl + '360x240?text=Image',
      seeUser: {},
      designations: [],
      designation: {},
      branches: [],
      settingRecordMemberStatus: '',
      branch: {},
      editMode: false,
      states: {},
      banks: {},
      staffs: [],
      staff: {},
      agents: [],
      ag: {},
      purposes: [],
      designation_id: '',
      form: new Form({
        id: '',
        name: '',
        alias: '',
        email: '',
        password: null,
        mobile: '',
        phone: '',
        gender: '',
        dob: '',
        photo: '',
        status: '',
        memberStatus: '',
        photoStatus: '',
        panPhoto: '',
        panStatus: '',
        voterCardPhoto: '',
        voterCardStatus: '',
        aadharPhoto: '',
        aadharBackPhoto: '',
        aadharStatus: '',
        rationCardPhoto: '',
        rationCardStatus: '',
        drivingLicencePhoto: '',
        drivingLicenceStatus: '',
        passbookPhoto: '',
        passbookStatus: '',
        pin: '',
        fatherName: '',
        motherName: '',
        spouseName: '',
        guarantorName: '',
        guarantorPhone: '',
        guarantorAddress: '',
        guarantorNarration: '',
        guarantorPanNo: '',
        guarantorPanStatus: '',
        guarantorAadharNo: '',
        guarantorAadharStatus: '',
        guarantorPan: '',
        guarantorAadhar: '',
        guarantorAadharBack: '',
        guarantorImage: '',
        address: '',
        staffStatus: '',
        area: '',
        city: '',
        district: '',
        state_id: '',
        panNo: '',
        aadharNo: '',
        drivingLicenceNo: '',
        rationCardNo: '',
        passportNo: '',
        voterIdCardNo: '',
        jobType: '',
        incomeAmount: '',
        incomeType: '',
        incomeTime: '',
        minAmount: '',
        maxAmount: '',
        businessName: '',
        businessAddress: '',
        officePhone: '',
        nomineeName: '',
        nomineePhone: '',
        nomineeSpouse: '',
        nomineeDob: '',
        nomineeAadharNo: '',
        group: '',
        bank_id: '',
        accountHolderName: '',
        accountNumber: '',
        bankBranch: '',
        dpn: '',
        demandProcessingNoteStatus: '',
        jlg: '',
        jointLiabilityGroupStatus: '',
        ifsc: '',
        branch_id: '',
        reference_id: Number,
        purpose_id: Number,
        reason_id: Number,
        agent_id: '',
        collection_center_id: Number,
        otp: ''
      }),
      // columns: [
      //   {
      //     label: 'CUST CODE',
      //     field: 'Code'
      //   },
      //   {
      //     label: 'CUST NAME',
      //     field: 'user.name'
      //   },

      //   {
      //     label: 'EMAIL',
      //     field: 'Email'
      //   },
      //   {
      //     label: 'FATHER NAME (C/O)',
      //     field: 'Father'
      //   },
      //   {
      //     label: 'MOB NUMBER',
      //     field: 'user.mobile'
      //   },
      //   {
      //     label: 'AGENT',
      //     field: 'agent.name'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },
      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    branchRecordWithchangeFilter () {
      this.form.branch_id = ''
      if (this.branch) {
        this.form.branch_id = this.branch.id
        this.loadStaff()
      }
      this.changeFilter()
    },
    downloadExcel () {

    },
    viewInfo () {
      Swal.fire('Cibil Score!', '<b>For Cibil Feature Please Contact Or whatsapp on +91-7017109788, 9911551344.</b>', 'info')
    },
    getAgentId () {
      this.form.agent_id = this.ag.user_id
    },
    imageZoom (imageName) {
      this.imagePreview = this.$store.state.imageDefaultUrl
      if (imageName) {
        this.imagePreview = imageName
      }
      $('#imagemodal').modal({backdrop: 'static', keyboard: false})
    },
    viewModal (row) {
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeUser = row
      if (this.seeUser.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/photo/' + this.seeUser.photo
      }
    },
    verifyModal (row) {
      this.seeUser = {}
      this.form.reset()
      $('#verifyModal').modal({backdrop: 'static', keyboard: false})
      this.seeUser = row
      this.form.fill(row)
      // this.form.status = this.seeUser.user.status
      this.form.status = this.seeUser.status

      if (this.seeUser.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/photo/' + this.seeUser.photo
      } else {
        this.photo = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorPhoto != null) {
        this.guarantorPhoto = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorPhoto/' + this.seeUser.guarantorPhoto
      } else {
        this.guarantorPhoto = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.panPhoto != null) {
        this.pan = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/pan/' + this.seeUser.panPhoto
      } else {
        this.pan = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.voterCardPhoto != null) {
        this.voterCard = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/voterCard/' + this.seeUser.voterCardPhoto
      } else {
        this.voterCard = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorPanPhoto != null) {
        this.guarantorPan = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorPan/' + this.seeUser.guarantorPanPhoto
      } else {
        this.guarantorPan = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.aadharPhoto != null) {
        this.aadhar = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/aadhar/' + this.seeUser.aadharPhoto
      } else {
        this.aadhar = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.aadharBackPhoto != null) {
        this.aadharBack = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/aadhar/' + this.seeUser.aadharBackPhoto
      } else {
        this.aadharBack = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorAadharPhoto != null) {
        this.guarantorAadhar = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorAadhar/' + this.seeUser.guarantorAadharPhoto
      } else {
        this.guarantorAadhar = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorAadharBackPhoto != null) {
        this.guarantorAadharBack = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorAadhar/' + this.seeUser.guarantorAadharBackPhoto
      } else {
        this.guarantorAadharBack = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.passbookPhoto != null) {
        this.passbook = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/passbook/' + this.seeUser.passbookPhoto
      } else {
        this.passbook = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.drivingLicencePhoto != null) {
        this.drivingLicence = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/drivingLicence/' + this.seeUser.drivingLicencePhoto
      } else {
        this.drivingLicence = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.demandProcessingNotePhoto != null) {
        this.dpn = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/demandProcessingNote/' + this.seeUser.demandProcessingNotePhoto
      } else {
        this.dpn = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.jointLiabilityGroupPhoto != null) {
        this.jlg = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/jointLiabilityGroup/' + this.seeUser.jointLiabilityGroupPhoto
      } else {
        this.jlg = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.rationCardPhoto != null) {
        this.rationCard = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/rationCard/' + this.seeUser.rationCardPhoto
      } else {
        this.rationCard = this.$store.state.imageDefaultUrl
      }
    },
    sendOTP () {
      // alert(this.seeUser.user_id)
      this.form.id = this.seeUser.id
      this.$axios
        .post('member/sendmemberotp', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Toast.fire({
            icon: 'success',
            title: 'One Time Password Send Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    verifyCustomerStatus () {
      this.form.id = this.seeUser.id
      this.$axios
        .post('member/memberkycstatus', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.form.status = ''
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Customer KYC Verify Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    verifyDocuments () {
      this.form.id = this.seeUser.id
      this.$axios
        .post('member/verifydocuments', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.form.status = ''
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Document Verify Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    sendOTPGuarantor () {
      this.form.id = this.seeUser.id
      this.$axios
        .post('member/sendguaranterotp', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Toast.fire({
            icon: 'success',
            title: 'One Time Password Send Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    sendOTPVerify () {
      this.form.id = this.seeUser.id
      this.$axios
        .post('member/verifymember', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Toast.fire({
            icon: 'success',
            title: 'Mobile Number Verify Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    sendOTPVerifyGuarantor () {
      this.form.id = this.seeUser.id
      this.$axios
        .post('member/verifyguaranter', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Toast.fire({
            icon: 'success',
            title: 'Mobile Number Verify Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getReferenceId () {
      this.form.reference_id = this.ro.user_id
    },
    docModal (row) {
      $('#docModal').modal({backdrop: 'static', keyboard: false})
      this.seeUser = {}
      this.seeUser = row
      if (this.seeUser.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/photo/' + this.seeUser.photo
      } else {
        this.photo = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorPhoto != null) {
        this.guarantorPhoto = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorPhoto/' + this.seeUser.guarantorPhoto
      } else {
        this.guarantorPhoto = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.panPhoto != null) {
        this.pan = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/pan/' + this.seeUser.panPhoto
      } else {
        this.pan = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.voterCardPhoto != null) {
        this.voterCard = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/voterCard/' + this.seeUser.voterCardPhoto
      } else {
        this.voterCard = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorPanPhoto != null) {
        this.guarantorPan = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorPan/' + this.seeUser.guarantorPanPhoto
      } else {
        this.guarantorPan = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.aadharPhoto != null) {
        this.aadhar = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/aadhar/' + this.seeUser.aadharPhoto
      } else {
        this.aadhar = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.aadharBackPhoto != null) {
        this.aadharBack = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/aadhar/' + this.seeUser.aadharBackPhoto
      } else {
        this.aadharBack = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorAadharPhoto != null) {
        this.guarantorAadhar = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorAadhar/' + this.seeUser.guarantorAadharPhoto
      } else {
        this.guarantorAadhar = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.guarantorAadharBackPhoto != null) {
        this.guarantorAadharBack = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorAadhar/' + this.seeUser.guarantorAadharBackPhoto
      } else {
        this.guarantorAadharBack = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.passbookPhoto != null) {
        this.passbook = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/passbook/' + this.seeUser.passbookPhoto
      } else {
        this.passbook = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.drivingLicencePhoto != null) {
        this.drivingLicence = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/drivingLicence/' + this.seeUser.drivingLicencePhoto
      } else {
        this.drivingLicence = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.demandProcessingNotePhoto != null) {
        this.dpn = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/demandProcessingNote/' + this.seeUser.demandProcessingNotePhoto
      } else {
        this.dpn = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.jointLiabilityGroupPhoto != null) {
        this.jlg = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/jointLiabilityGroup/' + this.seeUser.jointLiabilityGroupPhoto
      } else {
        this.jlg = this.$store.state.imageDefaultUrl
      }
      if (this.seeUser.rationCardPhoto != null) {
        this.rationCard = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/rationCard/' + this.seeUser.rationCardPhoto
      } else {
        this.rationCard = this.$store.state.imageDefaultUrl
      }
    },
    uploadPhoto (event) {
      const URL = 'member/photo'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('photo', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.photo = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/photo/' + response.data.photo.image_name
          Fire.$emit('AfterCreate')
          // console.log('image upload response ', response)
        }
      )
    },
    uploadPhotoGuarantor (event) {
      const URL = 'member/guarantorphoto'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('guarantorPhoto', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.guarantorPhoto = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorPhoto/' + response.data.guarantorPhoto.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadPan (event) {
      const URL = 'member/pan'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('pan', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.pan = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/pan/' + response.data.pan.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadVoterCard (event) {
      const URL = 'member/votercard'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('voterCard', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.voterCard = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/voterCard/' + response.data.pan.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadPanGuarantor (event) {
      const URL = 'member/guarantorpan'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('guarantorPan', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.guarantorPan = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorPan/' + response.data.guarantorPan.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadAadhar (event) {
      const URL = 'member/aadhar'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('aadhar', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.aadhar = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/aadhar/' + response.data.aadhar.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadAadharBack (event) {
      const URL = 'member/aadharback'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('aadharBack', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.aadharBack = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/aadhar/' + response.data.aadharBack.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadAadharGuarantor (event) {
      const URL = 'member/guarantoraadhar'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('guarantorAadhar', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.guarantorAadhar = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorAadhar/' + response.data.guarantorAadhar.image_name
          // console.log('guarantor image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadAadharBackGuarantor (event) {
      const URL = 'member/guarantoraadharback'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('guarantorAadharBack', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.guarantorAadharBack = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/guarantorAadhar/' + response.data.guarantorAadharBack.image_name
          // console.log('guarantor image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadPassbook (event) {
      const URL = 'member/passbook'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('passbook', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.passbook = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/passbook/' + response.data.passbook.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadRationCard (event) {
      const URL = 'member/rationcard'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('rationCard', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.rationCard = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/rationCard/' + response.data.rationCard.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadDL (event) {
      const URL = 'member/drivinglicence'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('drivingLicence', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.drivingLicence = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/drivingLicence/' + response.data.drivingLicence.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadDPN (event) {
      const URL = 'member/dpn'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('demandProcessingNote', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.dpn = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/demandProcessingNote/' + response.data.demandProcessingNote.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    uploadJLG (event) {
      const URL = 'member/jlg'
      let data = new FormData()
      data.append('user_id', this.seeUser.user_id)
      data.append('jointLiabilityGroup', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.jlg = this.$store.state.imageBaseUrl + this.seeUser.user_id + '/jointLiabilityGroup/' + response.data.jointLiabilityGroup.image_name
          // console.log('image upload response ', response)
          Fire.$emit('AfterCreate')
        }
      )
    },
    newModal () {
      this.loadState()
      this.form.staffStatus = 'active'
      this.editMode = false
      this.form.errors.errors = {}
      this.form.reset()
      var c = JSON.parse(localStorage.user)
      if (c.role.name !== 'Admin') {
        this.form.branch_id = c.agent_profile.branch_id
        if (c.role.name === 'Manager' || c.role.name === 'Branch Officer' || c.role.name === 'Accountant') {
          this.getBranchAgent()
        } else {
          this.form.agent_id = c.id
        }
      }
      var x = document.getElementById('uid')
      var y = document.getElementById('main')
      var z = document.getElementById('income')
      var r = document.getElementById('relation')
      // var n = document.getElementById('nominee')
      var a = document.getElementById('reference')
      x.style.display = 'none'
      $('.tab6').addClass('nav-link').removeClass('nav-link active')
      $('.tab5').addClass('nav-link').removeClass('nav-link active')
      $('.tab4').addClass('nav-link').removeClass('nav-link active')
      $('.tab3').addClass('nav-link').removeClass('nav-link active')
      $('.tab2').addClass('nav-link').removeClass('nav-link active')
      $('.tab1').addClass('nav-link active').removeClass('nav-link')
    //  document.getElementById('Identification').className = 'nav-link'
     // document.getElementById('mainDoc').className = 'nav-link active'
      y.style.display = 'block'
      r.style.display = 'none'
      z.style.display = 'none'
      // n.style.display = 'none'
      a.style.display = 'none'
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    saveMain () {
      // alert('hello')
      // $('#uid').attr('data-state') == 'enabled'
      var x = document.getElementById('uid')
      var y = document.getElementById('main')
      if (
        this.form.name !== '' &&
        this.form.mobile !== '' &&
        this.form.gender !== '' &&
        this.form.dob !== ''
      ) {
        if (this.form.name) {
          x.style.display = 'block'

          $('.tab1').addClass('nav-link').removeClass('nav-link active')
          $('.tab2').addClass('nav-link active').removeClass('nav-link')
        //  document.getElementById('Identification').className = 'nav-link active'
        //  document.getElementById('mainDoc').className = 'nav-link'
          y.style.display = 'none'
        }
      } else {
        if (this.form.branch_id === '') {
          this.form.errors.errors = {branch_id: ['The branch field is required.']}
        }
        if (this.form.dob === '') {
          this.form.errors.errors = { dob: ['The dob field is required.'] }
        }
        if (this.form.gender === '') {
          this.form.errors.errors = {gender: ['The gender field is required.']}
        }
        if (this.form.mobile === '') {
          this.form.errors.errors = {mobile: ['The mobile field is required.']}
        }
        if (this.form.name === '') {
          this.form.errors.errors = {name: ['The name field is required.']}
        }
      }
    },
    backMain () {
      var x = document.getElementById('uid')
      var y = document.getElementById('main')

      x.style.display = 'none'
      $('.tab2').addClass('nav-link').removeClass('nav-link active')
      $('.tab1').addClass('nav-link active').removeClass('nav-link')
    //  document.getElementById('Identification').className = 'nav-link'
     // document.getElementById('mainDoc').className = 'nav-link active'
      y.style.display = 'block'
    },

    backRel () {
      var x = document.getElementById('relation')
      var y = document.getElementById('uid')

      x.style.display = 'none'
      $('.tab3').addClass('nav-link').removeClass('nav-link active')
      $('.tab2').addClass('nav-link active').removeClass('nav-link')
     // document.getElementById('Identification').className = 'nav-link active'
    //  document.getElementById('relLoc').className = 'nav-link'
      y.style.display = 'block'
    },
    backInc () {
      var x = document.getElementById('income')
      var y = document.getElementById('relation')

      x.style.display = 'none'
      $('.tab4').addClass('nav-link').removeClass('nav-link active')
      $('.tab3').addClass('nav-link active').removeClass('nav-link')
     // document.getElementById('relLoc').className = 'nav-link active'
     // document.getElementById('inc').className = 'nav-link'
      y.style.display = 'block'
    },
    backRefer () {
      var x = document.getElementById('reference')
      var y = document.getElementById('income')

      x.style.display = 'none'
      $('.tab5').addClass('nav-link').removeClass('nav-link active')
      $('.tab4').addClass('nav-link active').removeClass('nav-link')
     // document.getElementById('inc').className = 'nav-link active'
     // document.getElementById('refer').className = 'nav-link'
      y.style.display = 'block'
    },
    // backNom () {
    //   var x = document.getElementById('nominee')
    //   var y = document.getElementById('reference')

    //   x.style.display = 'none'
    //   $('.tab6').addClass('nav-link').removeClass('nav-link active')
    //   $('.tab5').addClass('nav-link active').removeClass('nav-link')
    //   y.style.display = 'block'
    // },
    saveUID () {
      var x = document.getElementById('uid')
      var y = document.getElementById('relation')

      y.style.display = 'block'
      $('.tab2').addClass('nav-link').removeClass('nav-link active')
      $('.tab3').addClass('nav-link active').removeClass('nav-link')
    //  document.getElementById('Identification').className = 'nav-link'
    //  document.getElementById('relLoc').className = 'nav-link active'
      x.style.display = 'none'
      this.editMember()
    },
    saveRel () {
      var x = document.getElementById('income')
      var y = document.getElementById('relation')

      x.style.display = 'block'
      $('.tab3').addClass('nav-link').removeClass('nav-link active')
      $('.tab4').addClass('nav-link active').removeClass('nav-link')
    //  document.getElementById('inc').className = 'nav-link active'
    //  document.getElementById('relLoc').className = 'nav-link'
      y.style.display = 'none'
      this.editMember()
    },
    saveInc () {
      var x = document.getElementById('income')
      var y = document.getElementById('reference')

      y.style.display = 'block'
      $('.tab4').addClass('nav-link').removeClass('nav-link active')
      $('.tab5').addClass('nav-link active').removeClass('nav-link')
     // document.getElementById('inc').className = 'nav-link'
     // document.getElementById('refer').className = 'nav-link active'
      x.style.display = 'none'
      this.editMember()
    },
    // saveRefer () {
    //   var x = document.getElementById('nominee')
    //   var y = document.getElementById('reference')

    //   y.style.display = 'none'
    //   $('.tab5').addClass('nav-link').removeClass('nav-link active')
    //   $('.tab6').addClass('nav-link active').removeClass('nav-link')
    //   x.style.display = 'block'
    //   this.editMember()
    // },
    editModal (row) {
      this.form.staffStatus = 'active'
      this.loadState()
      this.editMode = true
      this.form.errors.errors = {}
      this.form.reset()
      var x = document.getElementById('uid')
      var y = document.getElementById('main')
      var z = document.getElementById('income')
      var r = document.getElementById('relation')
      // var n = document.getElementById('nominee')
      var a = document.getElementById('reference')
      x.style.display = 'none'
      $('.tab6').addClass('nav-link').removeClass('nav-link active')
      $('.tab5').addClass('nav-link').removeClass('nav-link active')
      $('.tab4').addClass('nav-link').removeClass('nav-link active')
      $('.tab3').addClass('nav-link').removeClass('nav-link active')
      $('.tab2').addClass('nav-link').removeClass('nav-link active')
      $('.tab1').addClass('nav-link active').removeClass('nav-link')
    //  document.getElementById('Identification').className = 'nav-link'
     // document.getElementById('mainDoc').className = 'nav-link active'
      y.style.display = 'block'
      r.style.display = 'none'
      z.style.display = 'none'
      // n.style.display = 'none'
      a.style.display = 'none'
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.alias = row.user.alias
      this.form.name = row.user.name
      this.form.email = row.user.email
      this.form.mobile = row.user.mobile
      this.getBranchAgent()
    },
    createMember () {
      if (this.form.email === null || this.form.email === '') {
        this.$delete(this.form, 'email')
        // this.form.bank_id = 4
      }
      if (this.form.bank_id === null || this.form.bank_id === '') {
        this.$delete(this.form, 'bank_id')
        // this.form.bank_id = 4
      }
      if (this.form.agent_id === null || this.form.agent_id === '') {
        this.$delete(this.form, 'agent_id')
        // this.form.bank_id = 4
      }
      this.$axios
        .post('member', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.form.status = ''
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          // $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Member Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    editMember () {
      if (this.form.jobType === null || this.form.jobType === '') {
        // this.$delete(this.form, 'jobType')
        this.form.jobType = 'NONE'
      }
      if (this.form.bank_id === null || this.form.bank_id === 0) {
        this.$delete(this.form, 'bank_id')
        // this.form.bank_id = ''
      }
      if (this.form.collection_center_id === null || this.form.collection_center_id === 0) {
        this.$delete(this.form, 'collection_center_id')
        // this.form.collection_center_id = 0
      }
      if (this.form.reference_id === null || this.form.reference_id === 0) {
        // this.$delete(this.form, 'reference_id')
        this.form.reference_id = 1
      }
      if (this.form.purpose_id === null || this.form.purpose_id === 0) {
        this.$delete(this.form, 'purpose_id')
        // this.form.purpose_id = 3
      }
      if (this.form.reason_id === null || this.form.reason_id === 0) {
        this.$delete(this.form, 'reason_id')
        // this.form.reason_id = 2
      }
      this.$axios
        .put('member/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.status = ''
          Fire.$emit('AfterCreate')
          // $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Member Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadState () {
      let loader = this.$loading.show()
      this.$axios
        .get('state?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.states = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadPurpose () {
      let loader = this.$loading.show()
      this.$axios
        .get('purpose?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.purposes = data.data
        })
        .catch(
          function (error) {
            loader.hide()
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.error
            })
            this.$router.push({'path': '/Error403'})
            // Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getBranchAgent () {
      var c = JSON.parse(localStorage.user)
      if (c.role.name === 'Admin' || c.role.name === 'Manager') {
        this.$axios.get('staff?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.agents = data.data
          _.forEach(this.agents, function (item, key) {
            this.agents[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.agent_id === item.user.id) {
              this.ag = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    },
    loadBank () {
      this.$axios
        .get('bank?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.banks = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    // loadData () {
    //   var c = JSON.parse(localStorage.user)
    //   // alert(c.role.name)
    //   if (c.role.name === 'Admin') {
    //     this.$axios.get('member?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rows = data.data
    //       _.forEach(this.rows, function (item, key) {
    //         this.rows[key].name = item.user.name + ' (' + item.user.code + ')'
    //       }.bind(this))
    //     })
    //     .catch(
    //       function (error) {
    //         Toast.fire({ icon: 'error', title: 'Please Try Again' })
    //         this.form.errors.errors = error.response.data.error
    //       }.bind(this)
    //     )
    //   } else if (c.role.name === 'Manager') {
    //     this.form.branch_id = c.agent_profile.branch_id
    //     this.$axios.get('member?all=all&branch_id=' + c.agent_profile.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rows = data.data
    //       _.forEach(this.rows, function (item, key) {
    //         this.rows[key].name = item.user.name + ' (' + item.user.code + ')'
    //       }.bind(this))
    //     })
    //     .catch(
    //       function (error) {
    //         Toast.fire({ icon: 'error', title: 'Please Try Again' })
    //         this.form.errors.errors = error.response.data.error
    //       }.bind(this)
    //     )
    //   } else {
    //     this.form.branch_id = c.agent_profile.branch_id
    //     this.$axios.get('member?all=all&agent_id=' + c.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rows = data.data
    //       _.forEach(this.rows, function (item, key) {
    //         this.rows[key].name = item.user.name + ' (' + item.user.code + ')'
    //       }.bind(this))
    //     })
    //     .catch(
    //       function (error) {
    //         Toast.fire({ icon: 'error', title: 'Please Try Again' })
    //         this.form.errors.errors = error.response.data.error
    //       }.bind(this)
    //     )
    //   }
    // },
    getDesignation () {
      this.$axios
        .get('designation?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.designations = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadStaff () {
      this.staffs = []
      this.staff = {}
      this.designation_id = this.designation.id
      var pageUrl = 'staff?all=all'
      if (this.form.staffStatus) {
        pageUrl += `&status=${this.form.staffStatus}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.designation_id) {
        pageUrl += `&designation_id=${this.designation.id}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      this.settingRecordMemberStatus = 'false'
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'member'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.staff.user_id) {
        pageUrl += `&agent_id=${this.staff.user.id}`
      }
      // if (c.type === 'admin') {
      //   if (this.form.branch_id) {
      //     pageUrl += `&branch_id=${this.form.branch_id}`
      //   }
      //   if (this.staff.user_id) {
      //     pageUrl += `&agent_id=${this.staff.user.id}`
      //   }
      // }
      // if (c.type !== 'admin') {
      //   if (c.role.name === 'Manager' || c.role.name === 'Accountant' || c.role.name === 'Branch Officer') {
      //     pageUrl += `&branch_id=${c.agent_profile.branch_id}`
      //     if (this.staff.user_id) {
      //       pageUrl += `&agent_id=${this.staff.user.id}`
      //     }
      //   } else {
      //     if (this.settingRecordMemberStatus === 'true') {
      //       pageUrl += `&branch_id=${c.agent_profile.branch_id}`
      //     } else {
      //       pageUrl += `&agent_id=${c.id}`
      //     }
      //   }
      // }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (this.form.status) {
        pageUrl += `&status=${this.form.status}`
      }
      if (this.name_search) {
        pageUrl += `&name=${this.name_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      if (c.role.name === 'Agent') {
        pageUrl += `&agent_id=${c.id}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
  },
  created () {
    this.loadSettings()
    this.loadBank()
    this.getBranch('true')
    this.getDesignation()
    // var c = JSON.parse(localStorage.user)
    // if (c.type === 'admin') {
    //   this.getBranch()
    //   this.getDesignation()
    // } if (c.type === 'staff') {
    //   this.form.branch_id = c.agent_profile.branch_id
    //   this.getStaff()
    // }
    this.changeFilter()
    this.loadPurpose()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
  img { 
    height:170px;
    width:240px;
    border-radius: 5%;
  }
  table.vgt-table {
  font-size:10px !important;
  border-collapse:collapse;
  background-color:#fff;
  width:100%;
  max-width:100%;
  table-layout:auto;
  border:1px solid #dcdfe6
  }
  /* .list-group-item {
    background-color: antiquewhite;
  } */
  .content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
  .border-primary {
    border: 3px solid #faf8f8;
    padding: 12px;
    border-radius:10px 10px 10px 10px;
  }
  .modal-body {
    max-height: calc(100vh - 212px);
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// Customer.vue?3bacd12b